// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__1n0yi","skeleton":"styles_skeleton__O-jB3","searcher":"styles_searcher__8ISkD"};